export interface TocConfigLike {
  items?: TocMenuItemLike[];
}

export enum TocMenuItemsDefault {
  BasemapList = 'basemapList',
  Themes = 'themes',
  AdditionalLayers = 'additionalLayers',
}

export interface TocMenuItemLike {
  icon?: string;
  title?: string;
  label?: string;
  name?: TocMenuItemsDefault | string;
  visible?: boolean;
  preservePosition?: boolean;
  data?: Array<TocBasemapItemConfigLike | TocLayerItemConfigLike | string>;
  showLegend?: boolean;
  canShowInHeatmap?: boolean;
}

export enum TocBasemapTypesDefault {
  Default = 'default',
}

export interface TocBasemapItemConfigLike {
  id: TocBasemapTypesDefault | string;
  isPortalItem?: boolean;
  imageUrl?: string;
  title?: string;
  visible?: boolean;
  preservePosition?: boolean;
}

export enum TocLayerItemConfigType {
  Feature = 'feature',
  MapImage = 'map-image',
  WMS = 'wms',
  Group = 'group',
}

export interface LayerParamsConfigLike {
  title?: string;
  visible?: boolean;
  maxScale?: number;
  minScale?: number;
}

export interface TocLayerItemConfigLike extends LayerParamsConfigLike {
  type: TocLayerItemConfigType;
  url?: string;
  sublayers?: Array<
    | number
    | string
    | ({ id: number } & LayerParamsConfigLike)
    | ({ name: string } & LayerParamsConfigLike)
  >;
  excludeSublayerIds?: Array<number>;
  excludeSublayerNames?: Array<string>;
  layers?: Array<TocLayerItemConfigLike>;
  canShowInHeatmap?: boolean;
  deferLoad?: boolean;
}
